import { arrayBufferToHex, sha256 } from '@gem/utils';

import { TStorageSessionRequestMethod } from '../types';

interface IGetCanonicalRequestHashParams {
  method: TStorageSessionRequestMethod;
  canonicalUri: string;
  canonicalQueryString?: string;
  canonicalHeaders: string;
  signedHeaders: string;
  payloadHash: string;
}

export async function getCanonicalRequestHash(
  params: IGetCanonicalRequestHashParams
): Promise<string> {
  const {
    method,
    canonicalHeaders,
    signedHeaders,
    payloadHash,
    canonicalUri,
    canonicalQueryString = '',
  } = params;
  const canonicalRequest = [
    method,
    canonicalUri,
    canonicalQueryString,
    canonicalHeaders,
    signedHeaders,
    payloadHash,
  ].join('\n');

  const sha256Request = await sha256(canonicalRequest);

  return arrayBufferToHex(sha256Request);
}
